import { jsx as _jsx } from "react/jsx-runtime";
import { Collapse } from "@mui/material";
import { forwardRef } from "react";
export const UiCollapse = forwardRef((props, ref) => (_jsx(Collapse, Object.assign({ ref: ref }, props))));
//# sourceMappingURL=ui_collapse.js.map